module.exports = __webpack_public_path__ + "static/img/Luke-Trainor.39d3464.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Luke-Trainor.jpg
// module id = NgE8
// module chunks = 0